import { GET_EXPLORER_DATA } from './actions';
import { SET_EXPLORER_DATA } from './mutations';
import HTTP from './../lib/HTTP';

const state = {
    data: {},
};

const mutations = {
    [SET_EXPLORER_DATA](_state, data) {
        _state.data = data;
    },
};

const actions = {
    [GET_EXPLORER_DATA](context, uri) {
        context.commit(SET_EXPLORER_DATA, null);

        return new Promise((resolve, reject) => {
            HTTP.get(`feeds/get?uri=${uri}`).then((res) => {
                console.log(res);
                if (res) {
                    context.commit(SET_EXPLORER_DATA, res.data === null ? false : res.data);
                }
                resolve(res);
            }).catch((err) => {
                console.log(err);
                reject(err);
            });
        });
    },
};

export default {
    state,
    mutations,
    actions,
};
